<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
    // 引入中文语言包
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

    export default {
        name: 'App',
        data() {
            return {
                locale: zhCN, // 绑定中文配置
            };
        },
    };
</script>

<style>
    #app {
        height: 100%;
    }
</style>